<template>
  <HomeworkPreview :list="list" :value="value" :showDownload="true"></HomeworkPreview>
</template>
<script>
import HomeworkPreview from "@/components/Homework/HomeworkPreview";

export default {
  name: "TeacherHomeworkPreview",
  components: {
    HomeworkPreview
  },
  data() {
    return {
      id: this.$route.query.id,
      list: [],
      value: {}
    };
  },
  async created() {
    let data = await this.$http.get("/api/homework/preview/" + this.id);
    this.list = data.detail;
    this.value = data.package;
  }
};
</script>